import { createFileRoute } from '@tanstack/react-router'
import { ReportSubscriptions } from '@/features/report-subscriptions'

export const Route = createFileRoute('/_authenticated/settings/report-subscriptions')({
  component: ReportSubscriptionsPage,
})

function ReportSubscriptionsPage() {
  return <ReportSubscriptions />
}
